'use strict';

var _ = require('lodash');
var OnlineLogitCalibrationChartDirective = function OnlineLogitCalibrationChartDirective(Chart, calibrationAnalysisConstants) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/online-logit-calibration-chart.html'),
    controller: 'OnlineLogitCalibrationChartController',
    scope: {
      chartType: '@',
      chartReviewData: '=',
      contextData: '=',
      services: '=',
      showTitle: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters, scope.chartType);
      scope.renderChartDataPresent = function (data) {
        chart.render(data);
      };
      scope.initLogitSharesData();
      scope.setLoadStateSliderValue();
      scope.$on('online-logit-calibration:grid-data-updated', scope.syncChartAfterGridUpdate);
      scope.$watch('chartReviewData.key', scope.updateView);
      scope.$watch('contextData.viewType', scope.handleViewTypeChange);
    }
  };
};
OnlineLogitCalibrationChartDirective.$inject = ['CalibrationReviewChart', 'CalibrationAnalysisConstants'];
module.exports = OnlineLogitCalibrationChartDirective;